import { render, staticRenderFns } from "./SBAllergies.vue?vue&type=template&id=a08c2df4"
import script from "./SBAllergies.vue?vue&type=script&lang=js"
export * from "./SBAllergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports